import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import VendorsPage from "./components/VendorsPage";
import BookingPage from "./components/BookingPage";
import BookingConfirmation from "./components/BookingConfirmation";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    // Comprehensive function to hide platform footer
    const hidePlatformFooter = () => {
      // Method 1: Hide by text content
      document.querySelectorAll('*').forEach(el => {
        const text = el.textContent || '';
        if (text.includes('Made with Emergent') || 
            text.includes('Made with emergent') ||
            (text.includes('Made with') && text.includes('Emergent'))) {
          el.style.display = 'none !important';
          el.style.visibility = 'hidden !important';
          el.style.opacity = '0 !important';
        }
      });

      // Method 2: Hide by common positioning patterns
      document.querySelectorAll('div, span, a').forEach(el => {
        const style = window.getComputedStyle(el);
        const text = el.textContent || '';
        
        if ((style.position === 'fixed' || style.position === 'absolute') &&
            (text.includes('Made with') || text.includes('Emergent'))) {
          el.style.display = 'none !important';
          el.style.visibility = 'hidden !important';
          el.style.opacity = '0 !important';
        }
      });

      // Method 3: Hide elements in bottom-right corner that contain "Made with"
      document.querySelectorAll('[style*="bottom"][style*="right"], [style*="position: fixed"]').forEach(el => {
        const text = el.textContent || '';
        if (text.includes('Made with') || text.includes('Emergent')) {
          el.style.display = 'none !important';
          el.style.visibility = 'hidden !important';
          el.style.opacity = '0 !important';
        }
      });

      // Method 4: Hide by common class patterns (if any)
      const selectors = [
        '[class*="footer"]',
        '[class*="brand"]',
        '[class*="powered"]',
        '[id*="footer"]',
        '[id*="brand"]'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          const text = el.textContent || '';
          if (text.includes('Made with') || text.includes('Emergent')) {
            el.style.display = 'none !important';
            el.style.visibility = 'hidden !important';
            el.style.opacity = '0 !important';
          }
        });
      });
    };

    // Run immediately
    hidePlatformFooter();
    
    // Run after React renders
    setTimeout(hidePlatformFooter, 100);
    setTimeout(hidePlatformFooter, 500);
    setTimeout(hidePlatformFooter, 1000);
    setTimeout(hidePlatformFooter, 2000);
    
    // Run periodically to catch dynamically added elements
    const interval = setInterval(hidePlatformFooter, 3000);

    // Also run on DOM changes
    const observer = new MutationObserver(() => {
      setTimeout(hidePlatformFooter, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vendors" element={<VendorsPage />} />
          <Route path="/booking/:vendorId" element={<BookingPage />} />
          <Route path="/confirmation/:bookingId" element={<BookingConfirmation />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;